/**
 * Most links a publisher website may offer per guest post. Same limit as the server
 * (PublisherWebsiteSettingsRules, 1..5) and the CSV import; new websites still default to 3.
 */
export const PUBLISHER_MAX_LINKS_PER_GUEST_POST = 5;
